<template>
    <b-sidebar draggable
      class="drwr-no-padding"
      :title="'Дэд бүртгэл: '+sharingTitle"
      @change="visibleChanged"
      v-model="showSideBar"
      width="40vw"
    >
      <div class="bg-white pd-20">
        <div style="overflow-y: auto">
          <table class="table-god table table-bordered w-full">
            <thead style="font-size: 10px">
              <tr>
                <th style="width: 40px">№</th>
                <th style="min-width: 200px">Дэд бүртгэл</th>
                <th style="width: 40px">Нэмэх
                  <feather @click="changePerBulk(boxes.filter(b=>b.isNew).length!=boxes.length, 0)" :type="boxes.filter(b=>b.isNew).length==boxes.length?'check-square':'square'"></feather>
                </th>
                <th style="width: 40px">Засах
                  <feather @click="changePerBulk(boxes.filter(b=>b.isEdit).length!=boxes.length, 1)" :type="boxes.filter(b=>b.isEdit).length==boxes.length?'check-square':'square'" ></feather>
                </th>
                <th style="width: 40px">Устгах
                  <feather @click="changePerBulk(boxes.filter(b=>b.isDelete).length!=boxes.length, 3)" :type="boxes.filter(b=>b.isDelete).length==boxes.length?'check-square':'square'" ></feather>
                </th>
                <th style="width: 40px">Холбох
                  <feather @click="changePerBulk(boxes.filter(b=>b.isConnect).length!=boxes.length, 2)" :type="boxes.filter(b=>b.isConnect).length==boxes.length?'check-square':'square'" ></feather>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr :key="i"
                v-for="(b, i) in boxes"
              >
                <td>{{i+1}}</td>
                <td>
                  {{b.box}}
                </td>
                <td class="text-center">
                  <a @click="changePer(b, 0)">
                    <feather
                      :type="b.isNew=='true'||b.isNew==true?'check-square':'square'"
                      ></feather>
                  </a>
                </td>
                <td class="text-center">
                  <a @click="changePer(b, 1)">
                    <feather
                      :type="b.isEdit=='true'||b.isEdit==true?'check-square':'square'"
                      ></feather>
                  </a>
                </td>
                <td class="text-center">
                  <a @click="changePer(b, 3)">
                    <feather
                      :type="b.isDelete=='true'||b.isDelete==true?'check-square':'square'"
                      ></feather>
                  </a>
                </td>
                <td class="text-center">
                  <a  @click="changePer(b, 2)">
                    <feather
                      :type="b.isConnect=='true'||b.isConnect==true?'check-square':'square'"
                      ></feather>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="taskdtl-drawer-footer">
          
        </div>
      </div>
    </b-sidebar>
</template>

<script>
import { request } from "@/api/all";

export default {
  name: "boxToColumnDrawer",
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    taskId: {
      type: Number,
      default: () => 0
    },
    executaFlag: {
      type: Number,
      default: () => 0
    },
    sharingModule: {
      type: Number,
      default: () => 2
    },
    sharingTitle: {
      type: String,
      default: () => ''
    },
    drwrW:{
      type: String,
      default: () => '40vw'
    }
  },
  watch: {
    show: function (newVal) {
      //console.log('wtching show prop', this.show);
      if (newVal) {
        this.init();
      }
    },
  },
  // computed: {
  //   isShowing: {
  //     get: function() {
  //       console.log('step 87');
  //       if (this.taskId != 0) {
  //         this.init();
  //       }
  //       return this.taskId != 0;
  //     },
  //     set: function() {}
  //   }
  // },
  data() {
    return {
      boxes: [],
      showSideBar: false
    };
  },
  methods: {
    changePer(b, action) {
      request({
            api: { method: "POST", url: "Column/PostBoxPermission" },
            data: { 
              columnId: this.taskId, 
              objectTypeId: b.boxObjectTypeId,
              ActionType: action
             },
            store: this.$store
        }).then(res => {
        if (res != false) this.init();
      });
    },
    changePerBulk(chk, action) {
      request({
            api: { method: "POST", url: "Column/PostBoxPermissionBulk" },
            data: { 
              columnId: this.taskId, 
              chk: chk,
              ActionType: action
             },
            store: this.$store
        }).then(res => {
        if (res != false) this.init();
      });
    },
    init() {
      request({
            api: { method: "GET", url: "Column/GetBoxSetting" },
            params: { columnId: this.taskId },
            store: this.$store
        }).then(res => {
            if(res!=false){
              this.boxes= res.boxes;
              this.showSideBar= true;
            }
          });
    },
    visibleChanged(e) {
      if (!e) {
        this.showSideBar= false;
        this.$emit("on-closed");
      }
    },
  }
};
</script>